import { Component, computed, input, output } from '@angular/core';
import { Modal } from 'flowbite';
import { ISuggestion } from 'src/app/models';
import { LiteralService } from 'src/app/services/literal/literal.service';
import {
  suggestionExpeditionLabel,
  suggestionVisibilityIcon,
} from 'src/app/utils/suggestionTickets';
import { images } from 'src/images';

@Component({
  selector: 'app-modal-public-ticket-preview',
  templateUrl: './modal-public-ticket-preview.component.html',
  standalone: false,
})
export class ModalPublicTicketPreviewComponent {
  readonly id = input.required<string>();
  readonly modal = input<Modal>();
  readonly suggestion = input<ISuggestion>();
  readonly action = output<void>();

  public images = images;

  readonly serviceLabel = computed(() => {
    const service = this.suggestion()?.service;
    if (!service) return '';
    return service.name ? `${service.tag}: ${service.name}` : service.tag;
  });

  readonly expeditionLabel = computed(() => suggestionExpeditionLabel(this.suggestion()?.expedition));

  readonly visibilityIcon = computed(() => suggestionVisibilityIcon(this.suggestion()?.visibility));

  constructor(public literalService: LiteralService) {}

  typeLabel() {
    const type = this.suggestion()?.type;
    return type ? this.literalService.get(`suggestions.${type.toLowerCase()}`, true) : '';
  }

  affairLabel() {
    const affair = this.suggestion()?.affair;
    return affair ? this.literalService.get(`suggestions.affairs.${affair}`, true) : '';
  }

  cancel() {
    this.modal()?.hide();
  }
}
